import React, {ChangeEventHandler, ReactElement, useState} from "react";
import {Col, Form, Row} from "react-bootstrap";
import {FormError} from "@src/components";
import {Maybe} from "@src/types/global.types";
import {AddressErrorType, AddressType} from "@src/types/address.types";
import {ProcessType} from "@process/types/process.types";


interface AddressFormProps {
    address: Maybe<AddressType>
    setAddress: Function
    formErrors?: Maybe<AddressErrorType>
}

const AddressForm: React.FC<AddressFormProps> = ({
     address, formErrors, setAddress
 }): ReactElement => {
    // const [address, setAddress] = useState<Maybe<AddressType>>(initAddress);

    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        // const name = e.target.name;
        // const value = e.target.value;

        setAddress({...address, [e.target.name]: e.target.value});
    }

    return (
        <>
            <Row>
                <Col sm={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Ulica</Form.Label>
                        <Form.Control type="text" name="street"
                              isInvalid={!!formErrors?.street}
                              value={address?.street ?? ''}
                              onChange={onChangeHandler}
                        />
                        <FormError errors={formErrors?.street} />
                    </Form.Group>
                </Col>
                <Col>
                    <Row>
                        <Col sm={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Nr budynku</Form.Label>
                                <Form.Control type="text" name="buildingNumber"
                                              isInvalid={!!formErrors?.buildingNumber}
                                              value={address?.buildingNumber ?? ''}
                                              onChange={onChangeHandler}
                                />
                                <FormError errors={formErrors?.buildingNumber} />
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Nr lokalu</Form.Label>
                                <Form.Control type="text" name="localNumber"
                                              isInvalid={!!formErrors?.localNumber}
                                              value={address?.localNumber ?? ''}
                                              onChange={onChangeHandler}
                                />
                                <FormError errors={formErrors?.localNumber} />
                            </Form.Group>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row>
                <Col sm={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Kod pocztowy</Form.Label>
                        <Form.Control type="text" name="postCode"
                                      isInvalid={!!formErrors?.postCode}
                                      value={address?.postCode ?? ''}
                                      onChange={onChangeHandler}
                        />
                        <FormError errors={formErrors?.postCode} />
                    </Form.Group>
                </Col>
                <Col sm={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Miejscowość</Form.Label>
                        <Form.Control type="text" name="city"
                                      isInvalid={!!formErrors?.city}
                                      value={address?.city ?? ''}
                                      onChange={onChangeHandler}
                        />
                        <FormError errors={formErrors?.postCode} />
                    </Form.Group>
                </Col>
            </Row>
        </>
    );
}

export default AddressForm;